import Query from '../../../components/Report';

export default new Query('search-summary-newurl-newkeyword');
